import { DateTime } from 'luxon';
import { SYDNEY_TIMEZONE } from './parse-timestamp';

const defaultDisplayMask = 'dd/MM/yyyy';

export default (
  value,
  parseMask,
  displayMask = defaultDisplayMask,
  toTimezone = SYDNEY_TIMEZONE
) => {
  if (!value) {
    throw new Error('A value is required to parse');
  }

  if (parseMask) {
    return DateTime.fromFormat(value, parseMask, {
      zone: toTimezone
    }).toFormat(displayMask, { locale: 'en-gb' });
  }

  return DateTime.fromISO(value, { zone: toTimezone }).toFormat(displayMask, {
    locale: 'en-gb'
  });
};
